import { render } from "./LandingPageView.vue?vue&type=template&id=3d0562ca&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"

import "./LandingPageView.vue?vue&type=style&index=0&id=3d0562ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0562ca"]])

export default __exports__